/*
  EB — <eb-autovideo>
  Video prodotto user-friendly: autoplay muto quando entra nel viewport,
  pausa quando esce, toggle play/pause minimale (niente barra controlli).
  - Rispetta la volontà utente: dopo un pause manuale non riparte da solo.
  - Resiliente a pauseAllMedia() (Dawn) che mette in pausa TUTTI i <video>
    allo switch di slide: se il video è in vista e l'utente non l'ha fermato,
    riparte.
  - prefers-reduced-motion: niente autoplay, resta il poster + toggle.
  - Il poster (immagine prodotto nitida) copre i primi frame finché parte
    la riproduzione (evita il "nero"/primo frame grezzo).
*/
if (!customElements.get('eb-autovideo')) {
  customElements.define(
    'eb-autovideo',
    class EbAutoVideo extends HTMLElement {
      connectedCallback() {
        if (this._inited) return;
        this._inited = true;

        this.video = this.querySelector('video');
        this.toggle = this.querySelector('.eb-vidtoggle');
        if (!this.video) return;

        this.userPaused = false; // true dopo un pause manuale
        this._selfPause = false; // true mentre metto in pausa io (observer)
        this._inView = false;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // Requisiti autoplay policy: muto + inline (a prescindere dagli attributi).
        this.video.muted = true;
        this.video.setAttribute('muted', '');
        this.video.playsInline = true;
        this.video.loop = true;
        this.video.removeAttribute('controls');

        this.video.addEventListener('playing', () => {
          // I video Essere fanno un FADE-IN DAL NERO: il frame 0 è nero.
          // Teniamo il poster (immagine prodotto nitida) ancora un attimo dopo
          // l'evento 'playing' (~250ms, pattern QM #38) così il nero iniziale
          // è mascherato, poi dissolviamo. Una volta dissolto, resta dissolto.
          if (!this._loadedTimer && !this.classList.contains('is-loaded')) {
            this._loadedTimer = setTimeout(() => {
              this.classList.add('is-loaded');
            }, 250);
          }
          this._sync();
        });
        this.video.addEventListener('play', () => this._sync());
        this.video.addEventListener('pause', () => this._onPause());

        // Click ovunque sul componente = toggle (affordance leggera, no player).
        this.addEventListener('click', (e) => {
          e.preventDefault();
          this._userToggle();
        });

        if (this.reduced) {
          // Niente autoplay: mostra poster, l'utente avvia a mano.
          this._sync();
          return;
        }

        this._io = new IntersectionObserver(
          (entries) => {
            entries.forEach((en) => {
              this._inView = en.isIntersecting && en.intersectionRatio >= 0.5;
              if (this._inView) {
                if (!this.userPaused) this._play();
              } else {
                this._pause();
              }
            });
          },
          { threshold: [0, 0.5, 1] }
        );
        this._io.observe(this);
        this._sync();
      }

      _play() {
        const p = this.video.play();
        if (p && p.catch) p.catch(() => {});
      }

      _pause() {
        this._selfPause = true;
        this.video.pause();
        this._selfPause = false;
      }

      // Pause "esterno" (es. Dawn pauseAllMedia allo switch di slide):
      // se il video è in vista e l'utente non l'ha fermato, riparte.
      _onPause() {
        this._sync();
        if (this._selfPause || this.userPaused || this.reduced) return;
        if (this._inView) this._play();
      }

      _userToggle() {
        if (this.video.paused) {
          this.userPaused = false;
          this._play();
        } else {
          this.userPaused = true;
          this._pause();
        }
        this._sync();
      }

      _sync() {
        const playing = !this.video.paused;
        this.classList.toggle('is-playing', playing);
        this.classList.toggle('is-paused', !playing);
        if (this.toggle) {
          this.toggle.setAttribute(
            'aria-label',
            playing ? 'Metti in pausa il video' : 'Riproduci il video'
          );
        }
      }

      disconnectedCallback() {
        if (this._io) this._io.disconnect();
      }
    }
  );
}
